import { Trans } from "@lingui/react";
import { WIcon } from "@mobility-item-page/client";
import { Button, Modal } from "@warp-ds/react";
import { useEffect, useState } from "react";

export const openReserveCarInfoEventId = "open-reserve-info";

export const ReserveCarInfoModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const listener = () => {
      setOpen(true);
    };
    window.addEventListener(openReserveCarInfoEventId, listener);
    return () => {
      window.removeEventListener(openReserveCarInfoEventId, listener);
    };
  }, []);

  const handleClose = () => setOpen(false);

  return (
    <Modal
      open={open}
      onDismiss={handleClose}
      title={
        <h2 className="text-ml md:text-l text-center m-0">
          <Trans id="dealer.dcbPopup.title" message="Reserve the car – how it works" />
        </h2>
      }
      footer={
        <Button utility fullWidth onClick={handleClose}>
          <Trans id="dealer.dcbPopup.close" message="Close" />
        </Button>
      }
    >
      <ul className="space-y-4">
        <li className="flex items-start gap-10 pb-8">
          <span className="ml-8 mt-2">
            <WIcon name="ArrowRight" />
          </span>
          <p className="text-base m-0">
            <Trans id="dealer.dcbPopup.detail1" message="Reserve the car for up to 48 hours at no cost." />
          </p>
        </li>
        <li className="flex items-start gap-10 pb-8">
          <span className="ml-8 mt-2">
            <WIcon name="ArrowRight" />
          </span>
          <p className="text-base m-0">
            <Trans id="dealer.dcbPopup.detail2" message="Fill in your details including personal number." />
          </p>
        </li>
        <li className="flex items-start gap-10 pb-8">
          <span className="ml-8 mt-2">
            <WIcon name="ArrowRight" />
          </span>
          <p className="text-base m-0">
            <Trans id="dealer.dcbPopup.detail3" message="Verify with BankID." />
          </p>
        </li>
        <li className="flex items-start gap-10 pb-8">
          <span className="ml-8 mt-2">
            <WIcon name="ArrowRight" />
          </span>
          <p className="text-base m-0">
            <Trans
              id="dealer.dcbPopup.detail4"
              message="The dealer receives your reservation and calls you within 24 hours during normal opening hours."
            />
          </p>
        </li>
        <li className="flex items-start gap-10 pb-8">
          <span className="ml-8 mt-2">
            <WIcon name="ArrowRight" />
          </span>
          <p className="text-base m-0">
            <Trans id="dealer.dcbPopup.detail5" message="Together you plan the next step in your buying process." />
          </p>
        </li>
      </ul>
    </Modal>
  );
};
